// extracted by mini-css-extract-plugin
module.exports = {"item":"feature-section-module--item--3oLI7","features":"feature-section-module--features--1prVZ"};